var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchCategoryMediaServices16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture-Category/16/Media-Services_16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linear-gradient-aws/Category-Icons/Arch-Category_16/Arch-Category_Media-Services_16.svg"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8511B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-Category/16/Media-Services_16",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linear-gradient-aws/Category-Icons/Arch-Category_16/Arch-Category_Media-Services_16.svg)",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "#879196-Border-Copy-16",
    stroke: "#879196",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Category/16/Media-Services_16",
    transform: "translate(8.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,9.917 L4,6.073 L7.361,7.896 L4,9.917 Z M4.351,5.127 C4.084,4.95 3.741,4.934 3.458,5.084 C3.176,5.236 3,5.529 3,5.85 L3,10.149 C3,10.47 3.176,10.763 3.458,10.915 C3.59,10.985 3.733,11.019 3.874,11.019 C4.038,11.019 4.198,10.973 4.331,10.884 L8.107,8.613 C8.35,8.451 8.494,8.181 8.494,7.89 C8.494,7.599 8.35,7.329 8.068,7.144 L4.351,5.127 Z M15,11 L14.101,11 L12.768,9 L10,9 L10,12.763 C10,12.893 9.894,13 9.763,13 L1.237,13 C1.106,13 1,12.893 1,12.763 L1,3.236 C1,3.106 1.106,3 1.237,3 L9.763,3 C9.894,3 10,3.106 10,3.236 L10,7 L12.768,7 L14.101,5 L15,5 L15,11 Z M15.132,4 L13.565,4 L12.232,6 L11,6 L11,3.236 C11,2.554 10.445,2 9.763,2 L1.237,2 C0.555,2 0,2.554 0,3.236 L0,12.763 C0,13.445 0.555,14 1.237,14 L9.763,14 C10.445,14 11,13.445 11,12.763 L11,10 L12.232,10 L13.565,12 L15.132,12 C15.61,12 16,11.61 16,11.131 L16,4.868 C16,4.389 15.61,4 15.132,4 L15.132,4 Z",
    id: "Media-Services_Category-Icon_16_Squid"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchCategoryMediaServices16);
export default __webpack_public_path__ + "static/media/Arch-Category_Media-Services_16.0b3cd5c89b398da7c1fa24e5556155d9.svg";
export { ForwardRef as ReactComponent };